import {
    DonutValueSetProp,
    toIterableValueSet,
    getVoidValue,
    getBackgroundColors,
    getRadiusRange,
    getValuesArray
} from './donut.utils';
import useTooltip from '../../../hooks/use-tooltip.hook';
import { useRef } from 'react';
import {
    donutOverlayClassName,
    donutOverlayContent65ClassName,
    donutOverlayContent75ClassName,
    donutOverlayContentClassName,
    donutWrapperClassName
} from './donut.style';
import { classes } from 'typestyle';
import Echarts from '../../layout/echarts/echarts.component';
import { EChartsType } from 'echarts';

interface Donut2Props {
    valueSet: DonutValueSetProp,
    children?: React.ReactNode
}

const Donut2: React.FC<Donut2Props> = ({
    children,
    ...props
}) => {
    const tooltip = useTooltip('hello world!', false);
    const valueSets = toIterableValueSet(props.valueSet);
    const valueSetsRef = useRef(valueSets);
    valueSetsRef.current = valueSets;
    let contentSizeClassName = valueSets.length <= 1 ? donutOverlayContent75ClassName : donutOverlayContent65ClassName;

    return (
        <div ref={ tooltip.ref } className={ donutWrapperClassName }>
            <Echarts
                series={ valueSets.map((valueSet, valueSetIndex) => {
                    return {
                        type: 'pie',
                        name: `ArcGroup-${valueSetIndex}`,
                        color: getBackgroundColors(valueSet.theme, valueSet.values.length),
                        radius: getRadiusRange(valueSetIndex, valueSets.length, !!children),
                        animation: true,
                        emphasis: {
                            disabled: true
                        },
                        avoidLabelOverlap: false,
                        label: {
                            show: false
                        },
                        labelLine: {
                            show: false
                        },
                        data: [
                            ...valueSet.values.map((value, valueIndex) => {
                                return {
                                    name: `${valueSetIndex}-${valueIndex}`,
                                    value: typeof value === 'number' ? value : value.value,
                                }
                            }),
                            {
                                name: `${valueSetIndex}-void`,
                                value: getVoidValue(
                                    getValuesArray(valueSet.values),
                                    valueSet.maxValue
                                )
                            }
                        ]
                    }
                }) }
                options={ {
                    renderer: 'canvas',
                    width: 1,
                    height: 1
                } }
                responsive={ (chart: EChartsType, container: HTMLDivElement) => ({
                    width: container.clientWidth,
                    height: container.clientWidth
                }) }
                run={ (chart: EChartsType, container: HTMLDivElement) => {
                    chart.on('mousemove', (params) => {
                        const { seriesIndex = 0, dataIndex } = params;
                        const currentValueSets = valueSetsRef.current;

                        const currentDonutValue = currentValueSets[seriesIndex]?.values[dataIndex];
                        const tooltipText = typeof currentDonutValue === 'object'
                            ? typeof currentDonutValue.tooltip === 'string'
                                ? currentDonutValue.tooltip
                                : currentDonutValue.tooltip ? String(currentDonutValue.value) : undefined
                            : undefined

                        if (tooltipText) {
                            tooltip.show(tooltipText);
                        }
                        else {
                            tooltip.hide();
                        }

                        chart.getZr().setCursorStyle('default');
                    });

                    chart.on('mouseout', params => {
                        tooltip.hide();
                    });

                    return () => {
                        chart.off('mousemove');
                        chart.off('mouseout');
                    }
                } }/>
            { children && (
                <div className={ donutOverlayClassName }>
                    <div className={ classes(donutOverlayContentClassName, contentSizeClassName) }>
                        { children }
                    </div>
                </div>
            ) }
        </div>
    );
};

export default Donut2;
